import { headerHeightLg, headerHeightMd, headerHeightSm } from '@/constants/layouts';
import { ROUTE_ACTION_PLAN, ROUTE_DASHBOARD } from '@/constants/routes';
import useIsMobile from '@/hooks/use-is-mobile';
import { getRoute } from '@/utils';
import HeaderBackground from '@/components/ui/header-background/header-background';
import { Flex, Grid, IconX, Image, Link } from '@cmpsr/components';
import { Link as ReactRouterLink } from 'react-router-dom';

export const Header = () => {
  const isMobile = useIsMobile();

  return (
    <Flex
      as="nav"
      justifyContent="center"
      alignItems="center"
      height={{ base: headerHeightSm, md: headerHeightMd, lg: headerHeightLg }}
      px={{ base: 'spacer-5', md: 'spacer-8', lg: 'spacer-16', xl: 'spacer-24', xxl: 'spacer-32' }}
      py={{ base: 'spacer-3', lg: 'spacer-6' }}
      position="relative"
      overflow="hidden"
    >
      <HeaderBackground />
      <Grid templateColumns="repeat(3, 1fr)" width="100%" maxW="1184px" justifyContent="space-between" flex={1} position="relative" zIndex={1}>
        <Link
          as={ReactRouterLink}
          width="auto"
          to={ROUTE_DASHBOARD}
          aria-label="Navigate home"
          margin="auto"
          gridColumnStart={2}
        >
          <Image src="/images/logo-catch.svg" height="25px" alt="Catch logo" />
        </Link>
        <Link
          as={ReactRouterLink}
          to={getRoute(ROUTE_ACTION_PLAN)}
          w="auto"
          size="m"
          ml="auto"
          color="white"
          trailingIcon={<IconX />}
        >
          {!isMobile && 'Close'}
        </Link>
      </Grid>
    </Flex>
  );
};

export default Header;
